<template>
    <div class="body" v-show="bodyShow">
        <div v-if="list.length>0">
            <div  class="homework" v-for="(item,index) in list" :key="index">
                <div class="homework-head">
                    <img :src="item.headimgurl" alt="">
                    <div class="all_homework-text">
                        <h3>{{item.name}}</h3>
                        <p>{{item.ctime}}</p>
                    </div>
                    <div class="homework-reply">
                        <!-- 把下标传给isShowComment数组 -->
                        <span class="on"  v-if="item.list.length >2 && !isShow[index]" @click="showComment(index)" >展开</span>
                        <span @click="commentHandle(index,item.name)">回复</span>
                    </div>

                </div>
                <!--  -->
                <div :class="['homework-content',index==(list.length-1)?'last':'']">
                    <h3 :class="['text',item.reply.length > 69?'on':'',fullShow[index]?'an':'']">{{item.reply}}</h3>
                    <p v-if="item.reply.length > 69 && !fullShow[index]" @click="fullText(index)">全文</p>
                    <!-- 评论 -->
                    <div v-for="(ite,inx) in item.list" :key="inx" v-show="item.list.length > 0 && isShowComment[index]" class="homework-comments" >
                        <img :src="ite.headimgurl" alt="">
                        <div>
                            <h4 class="on">{{ite.name}}</h4>
                            <h4>回复&nbsp;<span class="on">{{ite.rname}}：</span>{{ite.reply}}</h4>
                        </div>
                    </div>
                    <!--  -->
                    <div class="homework-box clearfix" @click="toReportProject(item.uid)">
                        <img :src="item.mpheadimgurl" alt="">
                        <div class="report">
                            <h3>{{item.mpname}}</h3>
                            <div class="report-bg">
                                {{item.pname}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="noComments" v-else>
            暂时没有评论
        </div>
        <!--  @blur="commentShow = false" -->
        <div :class="['inp',commentShow?'on':'']">
            <van-field
                :clearable="true"
                v-model="reply"
                type="textarea"
                ref="id"
                autofocus
                :placeholder="`回复${replyName}`"
               
                rows="1"
                autosize
            />
            <img @click="submitHandle"  src="@a/fly.png" alt="">
        </div>
    </div>
</template>

<script>
import { replyList,ReplySub } from "@/api/comments"
import { shareCon } from "@/utils/wxconfig";
export default {
    data(){
        return{
            isShow:[],
            bodyShow:false,
            list:[],
            fullShow:[],
            commentShow:false,
            isShowComment:[],
            index:0,
            reply:'',
            replyName:'',
        }
    },
    methods:{
        pullData(){
            replyList({
                cid: this.$route.query.cid,
                cpid:this.$route.query.cpid,
            })
            .then(data => {
                this.bodyShow = true;
                this.list = data.list;
            });
        },
        // 展开全文
        fullText(index){
            this.$set(this.fullShow,index,true);
        },
        // 是否显示评论
        showComment(index){
            this.$set(this.isShow,index,true);
            this.$set(this.isShowComment,index,true);
        },
        // 回复
        commentHandle(index,name){
            this.commentShow = true;
            this.$refs.id.focus();
            if(this.index!=index){
                this.reply = ''
            }
            this.index = index;
            this.replyName = name;
        },
        // 提交评论
        submitHandle(){
            ReplySub({
                cid: this.$route.query.cid,
                cpid:this.$route.query.cpid,
                uid:this.list[this.index].uid,
                reply_id:this.list[this.index].id,
                return_uid:this.list[this.index].reply_uid,
                reply:this.reply,
            })
            .then(data => {
                this.commentShow = false;
                this.reply = '';
                this.pullData();
            });
        },
        // 跳转报告页面
        toReportProject(uid){
            this.$router.push({
                path:'/project_report_new',
                query:{
                    cid:this.$route.query.cid,
                    cpid:this.$route.query.cpid,
                    uid:uid
                }
            });
        }
    },
    created(){
        this.pullData();
        shareCon("course",this);
    },
    watch:{
        reply(newVal,oldVal){
            if(newVal.length > 100){
                this.reply = newVal.slice(0, 100);
                this.$toast('最多只能输入' + 100 + '个字。/(ㄒoㄒ)/~~！');
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .homework{
        background-color: #fff;
        padding: 30px 30px 0px 30px;
        .homework-head{
            position: relative;
            margin-bottom: 15px;
            img{
                position: absolute;
                top:50%;
                transform: translateY(-50%);
                width:60px;
                height:60px;
                border-radius:50%;
            }
            .all_homework-text{
                margin-left: 76px;
                h3{
                    line-height: 1;
                    color: #0C1D66;
                    font-size: 26px;
                    font-weight: bold;
                }
                p{
                    color: #999999;
                    font-size: 20px;
                }
            }
            .homework-reply{
                position: absolute;
                top: 0;
                right: 0;
                text-align: center;
                border-radius:8px;
                font-size: 26px;
                padding: 0px 23px;
                line-height: 50px;
                background-color: #EB5032;
                color: #fff;
                span.on{
                    border-right: 1px solid #fff;
                    padding-right: 20px;
                    margin-right: 20px;
                }
            }
        }
        .homework-content{
            padding-left: 76px;
            border-bottom: 1px solid #CCCCCC;
            padding-bottom: 20px;
            h3.text{
                font-size: 26px;
                color: #333333;
                overflow: hidden;
                word-wrap:break-word;
            }
            h3.text.on{
                height: 100px;
            }
            h3.text.an{
                height: auto;
            }
            p{
                font-size: 28px;
                color: #0C1D66;
                margin-top: 17px;
                font-weight: bold;
                display: inline-block;
            }
            .homework-comments:nth-of-type(1){
                border-top: none;
            }
            .homework-comments{
                position: relative;
                margin-top: 30px;
                border-top: 1px solid #ccc;
                padding-top: 35px;
                font-size: 0;
                img{
                    width:60px;
                    height:60px;
                    border-radius:50%;
                    margin-right: 18px;
                    vertical-align: top;
                }
                div{
                    font-size: 26px;
                    color: #333;
                    display: inline-block;
                    .on{
                        color: #0C1D66;
                        font-weight: bold;
                    }

                }

            }
            .homework-box{
                padding: 30px 30px 20px 30px;
                position: relative;
                background-color: #F0F0F0;
                margin-top: 20px;
                img{
                    width: 60px;
                    height: 60px;
                    border-radius: 50%;
                    position: absolute;
                    top: 20px;
                    left: 30px;
                }
                .report{
                    margin-left: 74px;
                    h3{
                        color: #0C1D66;
                        font-size: 28px;
                        font-weight: bold;
                    }
                    .report-text{
                        font-size: 26px;
                        color: #333333;
                        line-height:30px;
                        height:60px;
                        overflow: hidden;
                        margin-top: 10px;
                    }
                    p{
                        font-size: 28px;
                        color: #0C1D66;
                        margin-top: 20px;
                        font-weight: bold;
                    }
                    .report-bg{
                        color: #fff;
                        font-size: 34px;
                        background-image: url(../../../assets/homework.png);
                        background-size: 100% 100%;
                        background-repeat: no-repeat;
                        height:100px;
                        line-height: 100px;
                        text-align: center;
                        overflow: hidden;
                        margin-top: 20px;
                    }
                }
            }
        }
        .homework-content.last{
            border-bottom: none;
        }

    }
    .inp{
        display: flex;
        align-items: center;
        position: fixed;
        bottom: -180px;
        left: 0;
        width: 100%;
        transition: all .3s;
        padding: 16px 22px 16px 30px;
        background-color: #F0F0F0;
        img{
            width: 50px;
            height: 50px;
            margin-left: 20px;
        }
    }
    .inp.on{
        bottom: 0;
    }
    .noComments{
        position: fixed;
        color: #666;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        font-size: 32px;
    }
</style>
<style lang="scss">
    .inp{
        .van-field__body{
            textarea{
                font-size: 26px;
                line-height: 40px;
                color: #333;
            }
        }
    }
</style>
